import type { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import type ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import type ObservableRacePage from '../../../Model/Observables/ObservableRacePage'
import type { IUseGiddyUp } from '../../Pages/Starters/IUseGiddyUp'
import { BaseBetType } from '../BaseBetType/BaseBetType'

export class QuinellaViewModel extends BaseBetType {
  constructor(params: {
    raceInfo: ObservableRacePage
    raceStarters: ko.Observable<{
      Key: ObservableRaceKey
      Value: ko.ObservableArray<IObservableStarter>
    }>
    selections: ko.ObservableArray<IObservableStarter>
    context: { bettingContext: BettingInformation }
    useGiddyUp: IUseGiddyUp
  }) {
    super(
      params.raceInfo,
      params.raceStarters,
      params.selections,
      params.context.bettingContext,
      params.useGiddyUp
    )
  }
}
